import banner from './banner.js';
import pages from './pages.js';
import carousels from './carousels.js';

function v4(backendAxiosInstance) {
  return {
    ...banner(backendAxiosInstance),
    ...pages(backendAxiosInstance),
    ...carousels(backendAxiosInstance)
  };
}

export { v4 as default };
//# sourceMappingURL=index.js.map
